/**
 * Created by GSP on 2/10/2015.
 */
define( 'menuItemsUtils',[
  'module',
  'settings',
  'underscore',
  'menuItems'
], function(
  module,
  Settings,
  _,
  MenuItems
) {
  'use strict';

  var MenuItemsUtils = 
  {
    getMenuItems: function() 
    {
      var cAccountRoles = Settings.get('cAccountRoles'),
        menuConfig = {}, subMenus, cMenuItem;
      // Per-user gates (user groups) resolved at login into a boolean setting.
      var settingAllows = function (item) {
        return !item.requiredSetting || Settings.get(item.requiredSetting) === true;
      };

      if (cAccountRoles) 
      {
        menuConfig.menuItems = [];
        _.each(MenuItems.build(), function (menuItem) 
        {
          subMenus = [];
          cMenuItem = _.clone(menuItem);
          cAccountRoles.DASHBOARD_WEBSHOP_LANDINGPAGES = true;
          cAccountRoles.DASHBOARD_WEBSHOP_LANDINGPAGES_URLS = true;
          // A group menu (e.g. CRM) may list several roles: shown to whoever
          // has any of them.
          var hasRole = cAccountRoles[cMenuItem.role] === true ||
            _.some(cMenuItem.roles || [], function (r) { return cAccountRoles[r] === true; });
          if (hasRole && settingAllows(cMenuItem) &&
              (!cMenuItem.advancedOnly || (cMenuItem.advancedOnly && Settings.configValue('advancedMode') === true)))
          {
            //main menu
            if ( _.isEmpty(cMenuItem.subMenu)) 
            {
              menuConfig.menuItems.push(cMenuItem);
            } else 
            {
              //subMenus
              _.each(cMenuItem.subMenu, function (subMenu) 
              {
                if (cAccountRoles[subMenu.role] === true && settingAllows(subMenu) &&
                    (!subMenu.advancedOnly || (subMenu.advancedOnly && Settings.configValue('advancedMode') === true)))
                {
                  subMenus.push(subMenu);
                } 
                else if (subMenu.role === 'VECTORIZATOR') 
                {
                  if (_.include(_.keys(cAccountRoles), 'VECTORIZATOR_ONLY_ASSIGN')) 
                  {
                    subMenus.push(subMenu);
                  }
                }
              });
              cMenuItem.subMenu = subMenus;
              menuConfig.menuItems.push(cMenuItem);
            }
          }
        });
      } else {
        menuConfig.menuItems = MenuItems;
      }

      return   menuConfig.menuItems;
    }
  };
  module.exports = MenuItemsUtils;
});
